import React, { useState } from "react";
import "./forgotPassword.scss";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { PasswordResetRequest } from "../../services/userService";
import Logo from "../../assets/images/logo.svg";
import SubmitButton from "../submitButton/submitButton";
import SuccessCard from "../successCard/successCard";

function ForgotPasswordComponent() {
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [loading, setLoadig] = useState(false);
  const [result, setResult] = useState("");

  const handleEmail = (e) => {
    setEmailError(false);
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      setEmailError(true);
    }
    if (email !== "") {
      try {
        setLoadig(true);
        let res = await PasswordResetRequest(email);
        setResult(res.message);
        setLoadig(false);
      } catch (err) {
        setLoadig(false);
        toast.error(err.error, { toastId: "error" });
      }
    }
  };

  return (
    <div className="forgotPassword">
      <ToastContainer position="top-center" rtl={true} closeButton={false} style={{fontSize:"0.875rem"}}/>
        {result !== "" ? <SuccessCard message={result} /> : (
          <div className="forgotPasswordContent">
            <div className="content">
              <img src={Logo} alt="logo" />
              <div className="title">بازیابی کلمه عبور</div>
              <p>ایمیلی که باهاش ثبت نام کرده بودی رو وارد کن</p>
            </div>
            <form>
              <label
                className={emailError ? "labelError" : ""}
                htmlFor="email"
              >
                ایمیل
              </label>
              <input
                className={emailError ? "inputError" : ""}
                type="email"
                onChange={(e) => handleEmail(e)}
                id="email"
                name="email"
                placeholder="ایمیلت رو اینجا بنویس"
                autoFocus
              />
              <SubmitButton onClick={handleSubmit} text="درخواست بازیابی" loading={loading} />
              <div className="options flex justify-between rtl">
                <div  onClick={() => {
                  navigate("/");
                }}>
                  بازگشت
                </div>
              </div>
            </form>
          </div>
        )}
    </div>
  );
}
export default ForgotPasswordComponent;
